import { TranslationLabels } from "translations/TranslationLabels";

export enum BoardStatusEnum {
  Unknown = 0,
  Deleted = 1,
  Draft = 2,
  Active = 3,
  Archived = 4,
}

/**
 * Gets the localized label for a BoardStatusEnum value.
 */
export function getBoardStatusLabel(value: BoardStatusEnum, i18n: TranslationLabels): string {
  switch (value) {
    case BoardStatusEnum.Unknown:
      return i18n.BoardStatus_Unknown;
    case BoardStatusEnum.Deleted:
      return i18n.BoardStatus_Deleted;
    case BoardStatusEnum.Draft:
      return i18n.BoardStatus_Draft;
    case BoardStatusEnum.Active:
      return i18n.BoardStatus_Active;
    case BoardStatusEnum.Archived:
      return i18n.BoardStatus_Archived;
    default:
      return `Unknown BoardStatusEnum: ${value}`;
  }
}
